import searchFill from '@iconify/icons-eva/search-fill';
import add from '@iconify/icons-ic/add';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import { Icon } from '@iconify/react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { useEffect, useMemo, useState } from 'react';
import { BiCloudDownload, BiCloudUpload } from 'react-icons/bi';
import { MdSend } from 'react-icons/md';
// import export from '@iconify/icons-ic/export';
// material
import CloseIcon from '@mui/icons-material/Close';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility';
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { DateRangeStyled, RootStyle, SearchStyle } from '../Global/Styling';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { fDate } from '../../utils/formatTime';
import Loader from '../Global/Loader';
import ApiErrorMessage from '../Global/ApiErrorMessage';

// Services
import RevenueService from '../services/RevenueService';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import { getBankBranchData } from '../../store/Slice/Global/GlobalSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const { DownloadMisDetails, UpdateStatus } = RevenueService;

// ----------------------------------------------------------------------

export default function RevenueToolbar({
  filterName,
  onFilterName,
  parent,
  children,
  selected,
  filterDatesRange,
  setFilterDatesRange,
  masterTypeOptions,
  setFilterParameter,
  filterParameter
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [downloadPopup, setDownloadPopup] = useState(false);
  const [addFilePopup, setAddFilePopup] = useState(false);
  const [syncPopup, setSyncPopup] = useState(false);
  const [isOpenFilter, openFilter] = useState(false);
  const [sendInvoice, setSendInvoice] = useState(false);

  // Extra state
  const [openLoader, setOpenLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [openApiError, setOpenApiError] = useState(false);

  const { LoanTypeDrop, BankBranchDrop, BankDrop } = useGlobalSelector();
  const { LoginData } = useLoginSelector();

  const handleRemoveFilter = (e) => {
    setFilterDatesRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ]);

    setFilterParameter({
      loanTypeId: null,
      bankId: null,
      branchId: null,
      misIsMatch: null,
      misIsMatchId: null
    });
  };

  const handleDownloadMISDetails = async () => {
    const bankIds = selected?.map((item) => item?.bankId);
    const revenueIds = selected?.map((item) => item?.revenueId);
    setDownloadPopup(true);
    const credential = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      fileFormat: 'csv',
      revenueIds: revenueIds,
      bankIds: bankIds
    };
    try {
      const DownloadMisDetailsResponse = await DownloadMisDetails(credential, LoginData?.jwt);

      const blob = await DownloadMisDetailsResponse.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'revenue-mis-file-template.csv');
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error('error', error);
    } finally {
      setDownloadPopup(false);
    }
  };

  const handleSendInvoice = async () => {
    const authToken = LoginData?.jwt;
    const credentials = selected.map((item) => ({
      fileNumber: item?.fileNumber || '',
      bankId: item?.bankId || ''
    }));

    console.log('selected for send invoice', selected);
    const { bankId, fileNumber } = selected[0];

    // const credentials = {
    //   fileNumber: fileNumber ? fileNumber : '',
    //   bankId: bankId ? bankId : ''
    // };

    try {
      setOpenLoader(true);
      const SendInvoiceResponse = await UpdateStatus(credentials, authToken);

      if (SendInvoiceResponse.status === '0') {
        setOpenApiError(true);
        // setErrorMessage(SendInvoiceResponse.msg);
        setErrorMessage('Invoice sent successfully!');
      } else if (SendInvoiceResponse.status === '1') {
        setOpenApiError(true);
        setErrorMessage(SendInvoiceResponse.msg);
      } else {
        setOpenApiError(true);
        setErrorMessage(SendInvoiceResponse.msg);
      }
    } catch (error) {
      setOpenApiError(true);
      setErrorMessage(error);
    } finally {
      setSendInvoice(false);
      setOpenLoader(false);
    }
  };

  const handleBranchDetails = (bankValue) => {
    if (!bankValue?.value) return '';
    dispatch(getBankBranchData(bankValue?.value));
  };

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs>
              <Autocomplete
                id="combo-box-demo2"
                options={BankDrop || []}
                size="small"
                getOptionLabel={(option) => option.label || ''}
                renderOption={(props, option) => <li {...props}>{option.label}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select Bank" />
                )}
                value={BankDrop?.find((item) => item.value === filterParameter?.bankId) || null}
                onChange={(e, newValue) => {
                  handleBranchDetails(newValue);
                  setFilterParameter((pre) => ({
                    ...pre,
                    branchId: null,
                    bankId: newValue?.value
                  }));
                }}
              />
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterParameter?.loanTypeId}`
                }}
                value={filterParameter?.loanTypeId || ' '}
                onChange={(e) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    loanTypeId: e.target?.value
                  }));
                }}
              >
                <MenuItem value=" " disabled>
                  Select Product
                </MenuItem>
                {LoanTypeDrop?.length > 0 &&
                  LoanTypeDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs sx={{ position: 'relative' }}>
              <Box className="displayDateRange">
                {filterDatesRange[0].startDate !== null
                  ? `${fDate(filterDatesRange[0].startDate)} to `
                  : ''}
                {filterDatesRange[0].endDate !== null ? fDate(filterDatesRange[0].endDate) : ''}
                {filterDatesRange[0].startDate === null && filterDatesRange[0].endDate === null ? (
                  <Typography className="dissabledMenu">Select Date Range</Typography>
                ) : (
                  ''
                )}
              </Box>
              <Select
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                MenuProps={{
                  className: 'menuOpened'
                }}
                value=" "
                className="datesSelect"
              >
                <DateRangeStyled
                  editableDateInputs={false}
                  onChange={(item) => setFilterDatesRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={filterDatesRange}
                  className="dateRangePicker"
                />
              </Select>
            </Grid>
            <Grid item xs>
              <Autocomplete
                sx={{ mr: 2 }}
                fullWidth
                disabled={!filterParameter?.bankId}
                id="combo-box-demo3"
                size="small"
                options={BankBranchDrop || []}
                getOptionLabel={(option) => option.label || ''}
                renderOption={(props, option) => <li {...props}>{option.label}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select Branch" />
                )}
                value={
                  BankBranchDrop?.find((item) => item.value === filterParameter?.branchId) || null
                }
                onChange={(e, newValue) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    branchId: newValue?.value
                  }));
                }}
              />
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterParameter?.misIsMatch}`
                }}
                value={filterParameter?.misIsMatchId || ' '}
                onChange={(e) => {
                  const selectedItem = masterTypeOptions?.statusOptions?.find(
                    (item) => item?.value === e.target?.value
                  );
                  setFilterParameter((pre) => ({
                    ...pre,
                    misIsMatch: selectedItem?.label || '',
                    misIsMatchId: e.target?.value
                  }));
                }}
              >
                <MenuItem value=" " disabled>
                  Select MIS Status
                </MenuItem>
                {masterTypeOptions?.statusOptions?.length > 0 &&
                  masterTypeOptions?.statusOptions?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          <Tooltip title="Add New File" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              onClick={(e) => navigate('/revenue/add-receipt')}
            >
              <Icon icon={add} width={18} />
            </IconButton>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Upload" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              onClick={(e) => navigate(`/${parent}/upload-receipt`)}
            >
              <BiCloudUpload size={18} />
            </IconButton>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Download" placement="top" arrow>
            <IconButton
              disabled={!selected?.length > 0}
              classes={{ disabled: 'disabledBtn' }}
              className="squareIconButton"
              onClick={(e) => setDownloadPopup(true)}
            >
              <BiCloudDownload size={18} />
            </IconButton>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          {children === 'disbursed' && (
            <Tooltip title="Send Invoice" placement="top" arrow>
              <IconButton
                disabled={selected?.length < 1}
                classes={{ disabled: 'disabledBtn' }}
                className="squareIconButton"
                onClick={(e) => setSendInvoice(true)}
              >
                <MdSend size={18} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        <Box sx={{ minWidth: '250px' }}>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Revenue"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Filter list">
            <IconButton
              onClick={(e) => {
                if (isOpenFilter) {
                  openFilter(false);
                } else {
                  openFilter(true);
                }
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
      {/* Download pop up start */}
      <Dialog
        className="PopupBox"
        open={downloadPopup}
        onClose={(e) => setDownloadPopup(false)}
        fullWidth
      >
        <DialogTitle className="popupTitle">
          <Typography variant="h6">Download</Typography>
          <IconButton onClick={(e) => setDownloadPopup(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2">Are you sure you want to download?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDownloadMISDetails} variant="contained" className="mainBtn">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {/* Download pop up end */}
      {/* Add file pop up start */}
      <Dialog
        className="PopupBox"
        open={addFilePopup}
        onClose={(e) => setAddFilePopup(false)}
        fullWidth
      >
        <DialogTitle className="popupTitle">
          <Typography variant="h6">Select Mode of File Creation</Typography>
          <IconButton onClick={(e) => setAddFilePopup(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3} display="flex" justifyContent="center" textAlign="center">
            <Grid item xs={4}>
              <Box className="appSubmissionLinkB" onClick={(e) => navigate('/revenue/add-receipt')}>
                <EmojiPeopleIcon className="appSubLinkIcon" />
                <Typography variant="subtitle1">Manual</Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box className="appSubmissionLinkB" onClick={(e) => navigate('/revenue/add-receipt')}>
                <SettingsAccessibilityIcon className="appSubLinkIcon" />
                <Typography variant="subtitle2">Fetch</Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      {/* Add file pop up end */}
      {/* Sync pop up start */}
      <Dialog className="PopupBox" open={syncPopup} onClose={(e) => setSyncPopup(false)} fullWidth>
        <DialogTitle className="popupTitle">
          <Typography variant="h6">Synced</Typography>
          <IconButton onClick={(e) => setSyncPopup(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2">27 records/files succefully synced.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => setSyncPopup(false)} variant="contained" className="mainBtn">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {/* Sync pop up end */}
      {/* send invoice popup start */}
      <Dialog
        className="PopupBox"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={sendInvoice}
        onClose={(e) => setSendInvoice(false)}
      >
        <DialogTitle className="popupTitle">
          <Typography variant="h6">Send Invoice</Typography>
          <IconButton onClick={(e) => setSendInvoice(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box variant="body1" mb={1} mt={1}>
            Are you sure you want to send this invoice ?
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSendInvoice} variant="contained" className="mainBtn">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {/* send invoice popup end */}
      <Loader openLoader={openLoader} />
      <ApiErrorMessage
        openApiError={openApiError}
        setOpenApiError={setOpenApiError}
        errorMessage={errorMessage}
      />
    </>
  );
}
